import type { fabric } from 'fabric';

export function fitObjectSize(
  zoomFactor: number,
  assetType:
    | 'video'
    | 'audio'
    | 'raster_image'
    | 'camera_raw_image'
    | 'vector_image'
    | 'document'
    | 'presentation'
    | 'spreadsheet'
    | 'website'
    | undefined
) {
  const scaleFactor = assetType === 'video' ? 8 : 3;
  const size = scaleFactor / (zoomFactor * 10);
  return size;
}

type FitPinSizeAssetType = Parameters<typeof fitObjectSize>[1];

const PIN_BASE_DIAMETER = 22;
const IMAGE_PIN_VISUAL_SCALE = 1.5;
const VIDEO_PIN_SCREEN_SIZE = 32;

function getVideoEffectiveZoom(canvas: fabric.Canvas): number {
  const zoom = canvas.getZoom() || 1;
  const internalWidth = canvas.getWidth();
  const clientWidth = canvas.getElement()?.clientWidth || internalWidth;

  if (internalWidth <= 0) return zoom;

  return (clientWidth * zoom) / internalWidth;
}

export function fitPinSize(
  zoomFactor: number,
  assetType?: FitPinSizeAssetType,
  canvas?: fabric.Canvas | null
) {
  if (assetType === 'video' || assetType === 'audio') {
    if (!canvas) {
      return VIDEO_PIN_SCREEN_SIZE / PIN_BASE_DIAMETER;
    }
    const effectiveZoom = getVideoEffectiveZoom(canvas);
    return VIDEO_PIN_SCREEN_SIZE / (PIN_BASE_DIAMETER * effectiveZoom);
  }
  return IMAGE_PIN_VISUAL_SCALE / (zoomFactor * 10);
}
